import { NavigationItem } from "@/navigation/types";
import hubConfig from "@/navigation/hubNavigation";
import adminConfig from "@/navigation/adminNavigation";
import stochasticConfig from "@/navigation/stochasticNavigation";
import eventRegistrationConfig from "@/navigation/eventRegistrationNavigation";
import dataConnectorConfig from "@/navigation/dataConnectorNavigation";
import employeeDirectoryConfig from "@/navigation/employeeDirectoryNavigation";
import partnerNetworkConfig from "@/navigation/partnerNetworkNavigation";
import {
  HomeIcon,
  Squares2X2Icon,
  Cog6ToothIcon,
  UsersIcon,
  UserGroupIcon,
  CalendarDaysIcon,
  ServerStackIcon,
  ShoppingBagIcon,
  SparklesIcon,
  CubeIcon,
  FolderIcon,
  BanknotesIcon,
} from "@heroicons/react/24/outline";

export function getUnifiedNavigation(): NavigationItem[] {
  return [
    {
      name: "Hub",
      internalName: "hub",
      href: "#",
      icon: HomeIcon,
      current: false,
      children: hubConfig.navigation,
    },
    {
      name: "Lead Generation",
      internalName: "stochastic",
      href: "#",
      icon: Squares2X2Icon,
      current: false,
      children: stochasticConfig.navigation,
    },
    {
      name: "Internal Admin",
      internalName: "admin",
      href: "#",
      icon: Squares2X2Icon,
      current: false,
      permissions: [
        "administration-events",
        "administration-email-management",
        "administration-resource-library",
        "administration-companies",
        "administration-users",
        "administration-stochastic",
      ],
      children: adminConfig.navigation,
      isCertainPathOnly: true,
    },
    {
      name: "Event Registration",
      internalName: "event-registration",
      href: "#",
      icon: CalendarDaysIcon,
      current: false,
      children: eventRegistrationConfig.navigation,
    },
    {
      name: "Shop",
      internalName: "shop",
      href: "#",
      icon: ShoppingBagIcon,
      current: false,
      children: [
        {
          name: "Total Access",
          href: "/subscriptions/total-access",
          icon: SparklesIcon,
          current: false,
          internalName: "total-access",
        },
        {
          name: "Products",
          href: "/product-directory",
          icon: CubeIcon,
          current: false,
          internalName: "product-directory-browse",
        },
      ],
    },
    {
      name: "Data Connector",
      internalName: "data-connector",
      href: "#",
      icon: ServerStackIcon,
      current: false,
      permissions: ["data-connector"],
      children: dataConnectorConfig.navigation,
    },
    {
      name: "Employee Directory",
      internalName: "employee-directory",
      href: "#",
      icon: UserGroupIcon,
      current: false,
      children: employeeDirectoryConfig.navigation,
    },
    {
      name: "Partner Network",
      internalName: "partner-network",
      href: "#",
      icon: BanknotesIcon,
      current: false,
      permissions: ["partner-network", "partner-network-admin"],
      children: partnerNetworkConfig.navigation,
    },
    {
      name: "Admin",
      internalName: "company-admin",
      href: "#",
      icon: Cog6ToothIcon,
      current: false,
      permissions: [
        "user-management",
        "company-profile",
        "integrations",
        "annual-revenue",
        "file-manager",
      ],
      children: [
        {
          name: "User Management",
          href: "/hub/users",
          icon: UsersIcon,
          current: false,
          internalName: "company_user_management",
          permissions: ["user-management"],
        },
        {
          name: "Company Settings",
          href: "/hub/settings",
          icon: Cog6ToothIcon,
          current: false,
          internalName: "company_settings",
          permissions: ["company-profile", "integrations", "annual-revenue"],
        },
        {
          name: "File Manager",
          href: "#file-manager",
          icon: FolderIcon,
          current: false,
          internalName: "file_manager",
          permissions: ["file-manager"],
          isDialog: true,
          dialogAction: "fileManager",
        },
      ],
    },
  ];
}
